import React from "react";

export default class Dekore extends React.Component {


    constructor(props) {
        super(props);
        this.state={
            farbeKorpus: APP.findProduct(this.props.arrangement.materials.corpus).Name,
            farbeFront: APP.findProduct(this.props.arrangement.materials.front).Name
        }
    }

    render() {
        return (
            <React.Fragment>
                <dt>{I18N('Dekore:')}</dt>
                <dd>{I18N('Korpus:')} {this.state.farbeKorpus}<br/>
                    {I18N('Front:')} {this.state.farbeFront}<br/></dd>
            </React.Fragment>
        );
    }
}
